import React from 'react';
import { AlertTriangle } from 'lucide-react';

// When a plan derivation produces impossible math (e.g. `Google Ad Origin %`
// exceeds 100% for Aug–Dec because spend ramp × pinned CPL implies more
// booked calls than the plan allows), render this badge on the tile.
// Rule from product: DO NOT CLAMP, DO NOT HIDE, DO SURFACE.
export function PlanInconsistencyBadge({ reason, testId }) {
  return (
    <span
      data-testid={testId || 'plan-inconsistency-badge'}
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.14em] font-semibold px-1.5 py-0.5 bg-amber-500 text-indie-ink"
      title={reason || 'Plan math produces an impossible value. Not clamped; surfaced so leadership can reconcile the inputs.'}
    >
      <AlertTriangle size={10} strokeWidth={2.5} />
      Plan inconsistency
    </span>
  );
}
